module.exports = __webpack_public_path__ + "static/img/TOM-ANASTASOPOULOS.9ca6091.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TOM-ANASTASOPOULOS.jpg
// module id = lTr2
// module chunks = 0